export class UploadedFileFormatIsNotAllowedBySpecifiedAcceptedField extends Error {}
